import { api } from "../api/api";
import { userLoggedIn } from "./authSlice";

export const authApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => ({ url: "/users", method: "GET" }),
        }),
        login: builder.mutation({
            query: (data) => ({
                url: "/login",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const { data } = await queryFulfilled;

                    localStorage.setItem(
                        "_auth",
                        JSON.stringify({
                            accessToken: data.accessToken,
                            user: data.user,
                        })
                    );

                    dispatch(
                        userLoggedIn({
                            accessToken: data.accessToken,
                            user: data.user,
                        })
                    );
                } catch (error) {}
            },
        }),
    }),
});

export const { useGetUsersQuery, useLoginMutation } = authApi;
